export const supportednfts = {

    'SP2KAF9RF86PVX3NEE27DFV1CQX0T4WGR41X3S45C.deruptars::deruptars': {
        value: 'deruptars',
        label: 'Deruptars',
        contract: 'SP2KAF9RF86PVX3NEE27DFV1CQX0T4WGR41X3S45C.deruptars::deruptars',
        imagehostprefix: 'https://raw.githubusercontent.com/cryptocracy/deruptars/main/number/',
        imagehostsuffix: '.png'
    },
    // 'SPJW1XE278YMCEYMXB8ZFGJMH8ZVAAEDP2S2PJYG.stacks-punks-v3::stacks-punks': {
    //     value: 'stacks-punks',
    //     label: 'Stacks Punks v3',
    //     contract: 'SPJW1XE278YMCEYMXB8ZFGJMH8ZVAAEDP2S2PJYG.stacks-punks-v3::stacks-punks',
    //     imagehostprefix: 'https://images.gamma.io/ipfs/QmbhuEQK3cCXk3Ev4DeNoq3pWFiErHgXibwkWwPHoLPxLq/punk',
    //     imagehostsuffix: '_lg.png'
    // },
    // 'SP6P4EJF0VG8V0RB3TQQKJBHDQKEF6NVRD1KZE3C.satoshibles::Satoshibles': {
    //     value: 'satoshibles',
    //     label: 'Satoshibles',
    //     contract: 'SP6P4EJF0VG8V0RB3TQQKJBHDQKEF6NVRD1KZE3C.satoshibles::Satoshibles',
    //     imagehostprefix: 'https://satoshibles.com/token/btc/',
    //     imagehostsuffix: '/small/image.png'
    // },
    // 'SPJW1XE278YMCEYMXB8ZFGJMH8ZVAAEDP2S2PJYG.bitcoin-birds::bitcoin-birds': {
    //     value: 'bitcoin-birds',
    //     label: 'Bitcoin Birds',
    //     contract: 'SPJW1XE278YMCEYMXB8ZFGJMH8ZVAAEDP2S2PJYG.bitcoin-birds::bitcoin-birds',
    //     imagehostprefix: 'https://images.gamma.io/ipfs/QmNcUCdjFK39Pk5iRrKY7Ez6hmqBcdnuxDZDAjTmeoxUqZ/bird-',
    //     imagehostsuffix: '.png'
    // },
    // 'SP2N3BAG4GBF8NHRPH6AY4YYH1SP6NK5TGCY7RDFA.stacks-mfers::stacks-mfers': {
    //     value: 'stacks-mfers',
    //     label: 'Stacks Mfers',
    //     contract: 'SP2N3BAG4GBF8NHRPH6AY4YYH1SP6NK5TGCY7RDFA.stacks-mfers::stacks-mfers',
    //     imagehostprefix: 'https://byzantion.mypinata.cloud/ipfs/QmUL7yELAmF1wnbqt6yaNLmCVbBa7BSbSNXYKijpku2r45/',
    //     imagehostsuffix: '.png'
    // },
    // 'SP2KAF9RF86PVX3NEE27DFV1CQX0T4WGR41X3S45C.bitcoin-monkeys::bitcoin-monkeys': {
    //     value: 'bitcoin-monkeys',
    //     label: 'Bitcoin Monkeys',
    //     contract: 'SP2KAF9RF86PVX3NEE27DFV1CQX0T4WGR41X3S45C.bitcoin-monkeys::bitcoin-monkeys',
    //     imagehostprefix: 'https://byzantion.mypinata.cloud/ipfs/QmYCnfeseno5cLpC75rmy6LQhsNYQCJabiuwqNUXMaA3Fo/',
    //     imagehostsuffix: '.png'
    // },
    // 'SP3QSAJQ4EA8WXEDSRRKMZZ29NH91VZ6C5X88FGZQ.crashpunks-v2::crashpunks-v2': {
    //     value: 'crash-punks',
    //     label: 'Crash Punks v2',
    //     contract: 'SP3QSAJQ4EA8WXEDSRRKMZZ29NH91VZ6C5X88FGZQ.crashpunks-v2::crashpunks-v2',
    //     imagehostprefix: 'https://byzantion.mypinata.cloud/ipfs/Qmb84UcaMr1MUwNbYBnXWHM3kEaDcYrKuPWwyRLVTNKELC/',
    //     imagehostsuffix: '.png'
    // },
    // 'SP1CSHTKVHMMQJ7PRQRFYW6SB4QAW6SR3XY2F81PA.the-guests::the-guests': {
    //     value: 'the-guests',
    //     label: 'The Guests',
    //     contract: 'SP1CSHTKVHMMQJ7PRQRFYW6SB4QAW6SR3XY2F81PA.the-guests::the-guests',
    //     imagehostprefix: 'https://byzantion.mypinata.cloud/ipfs/QmXbsvpfhCKFSVdE1m31p7rhWYDTA6P81f3NT3n5aVc6A7/images/',
    //     imagehostsuffix: '.png'
    // },
    // 'SP2X0TZ59D5SZ8ACQ6YMCHHNR2ZN51Z32E2CJ173.the-explorer-guild::The-Explorer-Guild': {
    //     value: 'the-explorer-guild',
    //     label: 'The Explorer Guild',
    //     contract: 'SP2X0TZ59D5SZ8ACQ6YMCHHNR2ZN51Z32E2CJ173.the-explorer-guild::The-Explorer-Guild',
    //     imagehostprefix: 'https://www.explorerguild.io/nft-images/?image=ar://Z4ygyXm-fERGzKEB2bvE7gx98SHcoaP8qdZQo0Kxm6Y/',
    //     imagehostsuffix: '.png&size=170'
    // },
    // 'SP27F9EJH20K3GT6GHZG0RD08REZKY2TDMD6D9M2Z.btc-badgers-v2::btc-badgers-nft-v2': {
    //     value: 'bitcoin-badgers',
    //     label: 'Bitcoin Badgers v2',
    //     contract: 'SP27F9EJH20K3GT6GHZG0RD08REZKY2TDMD6D9M2Z.btc-badgers-v2::btc-badgers-nft-v2',
    //     imagehostprefix: 'https://byzantion.mypinata.cloud/ipfs/QmWtLcsypXdSkZcqXJSjozFRvvK3Q3Hp5qBBLyuEBohtJ2/bitcoin_badger_',
    //     imagehostsuffix: '.gif'
    // },
    // 'SPJW1XE278YMCEYMXB8ZFGJMH8ZVAAEDP2S2PJYG.phases-of-satoshi::phases-of-satoshi': {
    //     value: 'phases-of-satoshi',
    //     label: 'Phases of Satoshi',
    //     contract: 'SPJW1XE278YMCEYMXB8ZFGJMH8ZVAAEDP2S2PJYG.phases-of-satoshi::phases-of-satoshi',
    //     imagehostprefix: 'https://www.stacksart.com/assets/phases/SAT_',
    //     imagehostsuffix: '.png'
    // },
    // 'SP32RTQPWQ6YE0AGQZP8K7TAW202B3NE4CNQMVJ4Q.humanoid-btc::humanoid-btc': {
    //     value: 'humanoid-btc',
    //     label: 'Humanoid BTC',
    //     contract: 'SP32RTQPWQ6YE0AGQZP8K7TAW202B3NE4CNQMVJ4Q.humanoid-btc::humanoid-btc',
    //     imagehostprefix: 'https://images.gamma.io/ipfs/QmdMoHYXV3pHYdGqksaqNGgG7sp1jhSMdCWwDWPE46oVHD/images/',
    //     imagehostsuffix: '.png'
    // },
    // 'SPXG42Y7WDTMZF5MPV02C3AWY1VNP9FH9C23PRXH.Marbling::Marbling': {
    //     value: 'marbling',
    //     label: 'Marbling',
    //     contract: 'SPXG42Y7WDTMZF5MPV02C3AWY1VNP9FH9C23PRXH.Marbling::Marbling',
    //     imagehostprefix: 'https://images.gamma.io/ipfs/QmTt5QKCopapZ3PwMubTC5qkGNrP6N65abMkBKz6FWvR1H/',
    //     imagehostsuffix: '.png'
    // },
    // 'SP1V19KW8DVQ5D8YPBVHBF9NZXWMC0Q4FGG7S9NRY.hungry-artists::hungry-artists': {
    //     value: 'hungry-artists',
    //     label: 'Hungry Artists',
    //     contract: 'SP1V19KW8DVQ5D8YPBVHBF9NZXWMC0Q4FGG7S9NRY.hungry-artists::hungry-artists',
    //     imagehostprefix: 'https://images.gamma.io/ipfs/QmZCcryGAvNJzS3rMGx3MRYnkEEXUUQ4sFotKhYwR7Gt2b/images/HA-',
    //     imagehostsuffix: '.png'
    // },
    'SP140MXYA1DSF1R0VZ5YGGQ5XR9FT5H7YTX26N2B8.bitcoin-beagle::bitcoin-beagle': {
        value: 'bitcoin-beagle',
        label: 'Bitcoin Beagle',
        contract: 'SP140MXYA1DSF1R0VZ5YGGQ5XR9FT5H7YTX26N2B8.bitcoin-beagle::bitcoin-beagle',
        imagehostprefix: 'https://raw.githubusercontent.com/cryptocracy/imgs/main/bitcoin-beagles/',
        imagehostsuffix: '.png'
    }

}

export const supportedOrigins = { "https://cloudflare-ipfs.com/ipfs": "https://cloudflare-ipfs.com/ipfs", "ipfs://ipfs": "https://ipfs.io/ipfs" }